import axios from 'axios';
//import store from '../store';

const intance = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        "Access-Control-Allow-Origin" : "*",
        "Access-Control-Allow-Headers" : "*",
        "Access-Control-Allow-Methods" : "*",
        "Content-type": "application/json",
        'Accept' : 'application/json',
        "x-user" : process.env.VUE_APP_X_USER,
        "x-keys" : process.env.VUE_APP_X_KEYS
    }
    
});


intance.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(error)
);

export default intance;
